<u2b-modal>
    <div u2bModalHeadline>{{ 'bcmBerthsMap.reservationDialog.title' | translate }}</div>

    <table class="simple table-sidebar">
        <thead>
            <tr>
                <th></th>
                <th>{{ 'bcmBerths.mapUi.berthLabel' | translate }}</th>
                <th>{{ 'bcmBerthsMap.reservationDialog.reservedUntil' | translate }}</th>
                <th>{{ 'bcmBerths.mapSidebar.cabinetNoteRow' | translate }}</th>
            </tr>
        </thead>

        <ng-container *ngFor="let berth of reservedAssignments">
            <tbody>
            <tr *ngIf="berth.endsToday">
                <td>
                    <mat-icon color="error" [matTooltip]="'bcmBerthsMap.reservationDialog.endsTodayTooltip' | translate">info icon</mat-icon>
                </td>
                <td>{{berth.berth.handle}}</td>
                <td>{{berth.to | dfnsFormat : 'dd.MM.yyyy HH:mm'}}</td>
                <td>{{berth.berth.note}}</td>

            </tr>
            <tr *ngIf="berth.endsThisWeek && !berth.endsToday">
                <td>
                    <mat-icon color="accent" [matTooltip]="'bcmBerthsMap.reservationDialog.endsThisWeekTooltip' | translate">info icon</mat-icon>
                </td>
                <td>{{berth.berth.handle}}</td>
                <td>{{berth.to | dfnsFormat : 'dd.MM.yyyy HH:mm'}}</td>
                <td>{{berth.berth.note}}</td>
            </tr>
            </tbody>
        </ng-container>
    </table>
</u2b-modal>
